import React, { useEffect, useRef, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import "./VersionChip.css";

// Collapsed by default (just the info icon); click expands to show the build
// version. Used in the overview sidebar and the bottom-right canvas controls.
export const VersionChip: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!expanded) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [expanded]);

  return (
    <div
      ref={ref}
      onClick={() => setExpanded((v) => !v)}
      className={`info-chip ${expanded ? "info-chip--expanded" : ""}`}
    >
      <div className="info-chip__text info-chip__text--left">
        <span>{__APP_VERSION__}</span>
      </div>
      <InfoOutlinedIcon className="icon-xs" />
    </div>
  );
};

/** The version chip's twin for an action: its label slides out while it is
 *  pointed at or focused, and a click runs it. */
export const ActionChip: React.FC<{
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  className?: string;
}> = ({ icon, label, onClick, className = "" }) => (
  // eslint-disable-next-line no-restricted-syntax -- the chip's own look; Button would box it
  <button
    type="button"
    className={`info-chip info-chip--reveal ${className}`}
    onClick={onClick}
  >
    <span className="info-chip__text info-chip__text--left">
      <span>{label}</span>
    </span>
    {icon}
  </button>
);
